export default __webpack_public_path__ + "static/media/arrow-down.50a1011d.svg";